import SectionTitle from '@/components/feature/SectionTitle';
import ScrollReveal from '@/components/feature/ScrollReveal';

const RECOVERY_ITEMS = [
  'Recuperação técnica de cilindros, bombas, motores e válvulas hidráulicas.',
  'Ideal quando o componente possui viabilidade técnica e econômica.',
  'Processos controlados, testes e engenharia aplicada.',
];

const SUPPLY_ITEMS = [
  'Fornecimento de componentes hidráulicos novos para reposição e manutenção.',
  'Apoio técnico na especificação do componente correto para cada aplicação.',
  'Solução indicada quando a substituição oferece maior confiabilidade ou melhor custo-benefício.',
];

export default function RecoverOrReplaceSection() {
  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <ScrollReveal>
          <SectionTitle
            overline="Recuperar ou Substituir?"
            title="Nem sempre a recuperação é a melhor alternativa"
            description="Nossa equipe técnica analisa cada componente e recomenda a solução mais adequada para reduzir o tempo de máquina parada, aumentar a confiabilidade do equipamento e otimizar o custo da manutenção."
          />
        </ScrollReveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Card 1 - Recuperação */}
          <ScrollReveal>
            <div className="bg-background-50 rounded-lg p-6 md:p-8 h-full border border-background-200/70">
              <div className="w-12 h-12 rounded-md bg-primary-100 flex items-center justify-center mb-5">
                <i className="ri-tools-line text-xl text-primary-500"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-4">
                Recuperação Especializada
              </h3>
              <ul className="space-y-3">
                {RECOVERY_ITEMS.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-primary-500 shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>

          {/* Card 2 - Componentes Novos */}
          <ScrollReveal delay={100}>
            <div className="bg-background-50 rounded-lg p-6 md:p-8 h-full border border-background-200/70">
              <div className="w-12 h-12 rounded-md bg-accent-100 flex items-center justify-center mb-5">
                <i className="ri-archive-line text-xl text-accent-500"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-4">
                Componentes Hidráulicos Novos
              </h3>
              <ul className="space-y-3">
                {SUPPLY_ITEMS.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}